import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import { Subject, Observable } from 'rxjs';
import { IUser } from 'src/app/interface/user';
import { YetiSocket } from '../yeti-socket';
import { environment } from 'src/environments/environment';
import { StringHelper } from 'src/app/helper/string/string-helper';
import { AuthService } from 'src/app/service/auth/auth.service';

@Injectable({
	providedIn: 'root',
})
export class CrewUpdatedService {
	private echo: Echo<any>;
	private subject: Subject<IResponse>;
	private listenEvent: string;
	private channelEvent: string;

	constructor(private authService: AuthService) {
		this.echo = YetiSocket.connect();
		this.subject = new Subject<IResponse>();
	}

	/**
	 * Create channel.
	 * @param companyId 
	 * @returns 
	 */
	public createChannel(companyId: number): void {
		if (!companyId) {
			return;
		}

		const channelEvent = StringHelper.sprintf(
			'%s_%d',
			environment.socketChannel,
			companyId
		);
		const listenEvent = '.crew_updated';

		if (
			this.channelEvent == channelEvent &&
			this.listenEvent == listenEvent
		) {
			return;
		}

		// Keep only one instance. Remove the old ones to start a new channel and listener.
		if (this.channelEvent) {
			this.echo
				.channel(channelEvent)
				.stopListening(listenEvent);
			this.echo
				.leaveChannel(channelEvent);
		}

		this.channelEvent = channelEvent;
		this.listenEvent = listenEvent;
		// Create a instance one.
		this.echo
			.channel(this.channelEvent)
			.listen(this.listenEvent, (data: IResponse) => {
				this.authService.setShiftFromCrew(data.crew);
				this.subject.next(data);
			});
	}

	public listener(): Observable<IResponse> {
		return this.subject?.asObservable();
	}

	public local(crew?: Array<IUser>) {
		this.authService.setShiftFromCrew(crew ?? []);
		this.subject.next({ crew });
	}
}

interface IResponse {
	message?: string;
	crew?: Array<IUser>;
}
